import { requiredHouseNumber } from "core/model/assessment/requiredHouseNumber";
import { preprocessZipcode, validateZipcode } from "core/model/utils/location";
import {
  convertModelDefinition,
  encryptedDef,
  required,
} from "react-forms-state";

export { requiredHouseNumber };

export const getModelDefinition = (
  country: any,
  encryptionActivated: boolean,
) =>
  convertModelDefinition({
    city: {
      default: null,
      out: "city",
      validate: required(),
    },
    floor: {
      convertOut: (value: any) => value?.trim() || null,
      default: null,
      out: "floor",
    },
    house_number: {
      default: null,
      out: "house_number",
      validate: (value: any, props: any) =>
        requiredHouseNumber({
          search_type: props.search_type,
          share_patient_data_automatically:
            props.share_patient_data_automatically,
          solutions: props.solutions,
        }) && encryptionActivated
          ? required()(value)
          : true,
    },
    street: {
      convertOut: (value: any) => value.trim(),
      default: null,
      out: "street",
      validate: required(),
    },
    ...encryptedDef("encrypted_house_number"),
    country: {
      convertOut: () => country,
      default: null,
      out: "country",
    },
    zipcode: {
      // @ts-expect-error
      convertOut: preprocessZipcode(),
      default: null,
      out: "zipcode",
      validate: validateZipcode(true),
    },
  });
